export default function (selectedForm) {
  return {
    selectedForm: null,
    formContainerHeight: 0,
    onResize: null,
    init() {
      this.selectedForm = selectedForm;
      this.updateParamGetUrl();

      setTimeout(() => {
        this.updateFormContainerHeight();
      }, 1000);

      this.onResize = () => {
        this.updateFormContainerHeight();
      };
      window.addEventListener('resize', this.onResize);

      this.$watch('selectedForm', (value) => {
        console.log('selectedForm changed to', value);
        this.updateParamGetUrl();
        this.updateFormContainerHeight();
      });
    },
    getHiddenElementHeight(element) {
      if (!element) {
        return 0;
      }

      const clone = element.cloneNode(true);
      clone.style.display = 'block';
      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      clone.style.pointerEvents = 'none';
      clone.style.left = '-9999px';
      clone.style.top = '0';
      clone.style.height = 'auto';
      clone.style.maxHeight = 'none';

      document.body.appendChild(clone);
      const height = clone.scrollHeight + 40;
      clone.remove();

      return height;
    },
    updateFormContainerHeight() {
      if (window.innerWidth < 1024) {
        this.formContainerHeight = 0;
        if (this.$refs.formWrapper) {
          this.$refs.formWrapper.style.minHeight = 'auto';
        }
        return;
      }

      const root = this.$el || document;
      const formContainers = root.querySelectorAll('.formContainer');
      const heights = Array.from(formContainers, (element) => {
        return this.getHiddenElementHeight(element);
      });

      this.formContainerHeight = heights.length ? Math.max(...heights) : 0;

      if (this.$refs.formWrapper) {
        this.$refs.formWrapper.style.minHeight = this.formContainerHeight + 'px';
      }
    },
    updateParamGetUrl() {
      const url = new URL(window.location.href);
      url.searchParams.set('formType', this.selectedForm);
      window.history.replaceState({}, '', url);
    }
  };
}
